<template>
    <div class="py-5">
        <v-row>
            <create-route typeTrip="RETURN"></create-route>
            <add-student></add-student>           
        </v-row>
        <v-row>
            <v-col>
                <v-card elevation="0" class="pt-5">
                    <routes-table :returnTrip="true" :selected="selected" :tableOptions="tableOptions" @re-fetch-data="fetchData"
                        @re-fetch-paginated-data="fetchData($event)">
                    </routes-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import createRoute from './createRoute.vue'
import showRestrictions from './showRestrictions.vue'
import generateRestrictions from './generateRestrictions.vue'
import addStudent from './addStudentToRoute.vue'
import { driverRoute } from '../../../store/driverRoutes'
import routesTable from '../../../components/base/routesTable.vue'
export default {
    components: {
        createRoute,
        routesTable,
        addStudent,
        showRestrictions,
        generateRestrictions,
    },
    data() {
        return {
            driverRoute,
            selected:{
                id:null,
                check:false,
            }            
        }
    },
    methods: {
        fetchData(page) {
            let params = {
                page: page,
                type: "RETURN",
            }
            driverRoute.getRoutes(params)
        },
    },
    computed: {
        tableOptions() {
            return driverRoute.driversTable
        }
    },
    mounted() {
        let params = {
                page: 1,
                type: "RETURN",
            }
        driverRoute.getRoutes(params)
    },
}
</script>